module.exports = __webpack_public_path__ + "static/img/pic1.3fccf58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case3/pic1.jpg
// module id = P6II
// module chunks = 1